/**
 * Compatibility layer between the old Yii bookmarks API (keyed by advert id)
 * and the new user bookmarks API (keyed by canonical id).
 *
 * When `SiteInfo.bookmarksPageActive` is true the new user API is in use and
 * bookmark state is matched by canonical id; otherwise the legacy Yii API is
 * active and everything is keyed by advert id. All client-side bookmark state
 * comparisons must go through these helpers so a single flag switches the
 * identity consistently.
 */

/** Identity of the advert shown on the current single-advert page. */
export const currentBookmarkId = (): string => (SiteInfo.bookmarksPageActive ? SiteInfo.canonicalId : SiteInfo.advertId)

/** Identity of a bookmark entry coming from the API or DOM. */
export const bookmarkIdOf = (entry: { advertId: number | string; canonicalId: string }): string =>
    SiteInfo.bookmarksPageActive ? entry.canonicalId : entry.advertId.toString()
